export const FIELD_TEXT        = 'FIELDS_INPUT_TEXT';
export const FIELD_TEXTAREA    = 'FIELDS_INPUT_TEXTAREA';
export const FIELD_TITLE       = 'FIELDS_ELEMENT_TITLE';
export const FIELD_DESCRIPTION = 'FIELDS_ELEMENT_DESCRIPTION';
